<template>
  <a-row type="flex" justify="space-between">
    <a-col :span="12">
      <a-row type="flex" justify="space-between" align="bottom" style="margin-bottom: 30px">
        <a-col :span="14" class="titulo">Gestor de Usuarios</a-col>
        <a-col><a-button type="primary" size="large" @click="openedCreateVarForm()">Agregar nuevo
            usuario</a-button></a-col>
      </a-row>
    </a-col>
    <a-col :span="12" />
    <a-col :span="12"
      style=" word-break: break-all; background-color: white; padding: 20px 10px 5px; border-radius: 5px;"
      class="shadow">
      <a-row style="display: flex;  justify-content: flex-end; margin-bottom:20px">
        <a-input-search placeholder="Filtrar por Nombre" v-model="filtroNombre" style="width: 200px;" />
      </a-row>
      <a-row>
        <a-table :columns="columnsListTable" :dataSource="filterVariables" rowKey="username" :pagination="pagination">
          <span slot="action" slot-scope="text, record">
            <a-button type="primary" shape="circle" icon="edit" @click="openEditVariable(record.id)"></a-button>
          </span>
        </a-table>
      </a-row>
    </a-col>
    <a-col :span="10">
      <a-form v-if="openedVarForm" layout="vertical" :form="formVar" @submit="submitVar">
        <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px" v-if="isEdit">
          Actualizar Usuario:
        </h1>
        <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px" v-else>
          Crear Nuevo Usuario:
        </h1>
        <a-form-item style="display: none;">
          <a-input v-decorator="['id']" class="shadowInputs" />
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Nombre Usuario
          </span>
          <a-input v-decorator="[
            'username',
            {
              rules: [
                {
                  required: true,
                  message: 'Ingrese un nombre para este variable',
                },
              ],
            },
          ]" class="shadowInputs" />
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Contraseña <span v-if="this.isEdit" style="font-size: 10px;color:#666">(dejar en blanco para mantener contraseña actual)</span>
          </span>
          <a-input type="password" v-decorator="[
            'password',
            {
              rules: [
                {
                  required: !this.isEdit,
                  message: 'Ingrese una contraseña',
                },
              ],
            },
          ]" class="shadowInputs" />
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Nivel
          </span>
          <a-select ref="select" size="large" class="shadowInputs" v-decorator="['isAdmin', {
            rules: [
              {
                required: true,
                message: 'Seleccione un nivel',
              },
            ],
            initialValue:'0',
          }]">
            <a-select-option value="1">Admin</a-select-option>
            <a-select-option value="0">Normal</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="isEdit">
          <span slot="label">
            Estado
          </span>
          <a-select ref="select" size="large" class="shadowInputs" v-decorator="['state', {
            rules: [
              {
                required: true,
                message: 'Seleccione un estado',
              },
            ],
          }]">
            <a-select-option value="1">Activo</a-select-option>
            <a-select-option value="0">Inactivo</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-row type="flex" justify="end" align="middle" :gutter="20">
            <a-col v-if="isEdit"><a-button type="primary" html-type="submit" size="large">Actualizar
                Usuario</a-button></a-col>
            <a-col v-else><a-button type="primary" html-type="submit" size="large">Guardar Usuario</a-button></a-col>
            <a-col><a-button @click="openedVarForm = false" size="large">Cancelar</a-button></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-col>
  </a-row>
</template>

<script>
import utils from '../service/service.js'
export default {
  name: "usuario",
  // props: {},
  mixins: [utils],
  data() {
    return {
      isAdmin: "0",
      usuarios: [],
      columnsListTable: [
        {
          title: "Usuario",
          dataIndex: "username",
        },
        {
          title: "Rol",
          dataIndex: "nivel",
        }, {
          title: "Estado",
          dataIndex: "stateName",
        },
        {
          title: "Acciones",
          scopedSlots: { customRender: "action" },
          width: "120px",
        },
      ],
      pagination: { pageSize: 8 },
      openedVarForm: false,
      filtroNombre: "",
      isEdit: false,
      formVar: this.$form.createForm(this)
    };
  },
  mounted: function () {
    this.cargarVariables();
  },
  methods: {
    submitVar(e) {
      e.preventDefault();
      this.formVar.validateFields(async (err) => {
        if (err !== null) { return false; }
        const data = this.formVar.getFieldsValue();
        let url = "";
        if (this.isEdit) {
          url = `users/edit`;
        } else {
          url = `users/register`;
        }
        const { code, message } = await this.sendRequest({
          method: 'POST',
          url: url,
          data: data,
        })
        if (code === 200) {
          this.$message.success(message)
          this.cargarVariables();
          this.openedVarForm = false;
        }
      });
    },
    openedCreateVarForm() {
      this.isEdit = false;
      this.formVar.resetFields();
      this.openedVarForm = true;
    },
    openEditVariable(id) {
      this.isEdit = true;
      return new Promise((resolve) => {
        const usuario = this.usuarios.find((variable) => { return variable.id == id; });
        this.openedVarForm = true;
        delete usuario.nivel;
        delete usuario.stateName;
        resolve(usuario);
      }).then((data) => {
        this.formVar.setFieldsValue(data);
      });
    },
    async cargarVariables() {
      const { data } = await this.sendRequest({
        method: 'GET',
        url: 'users/list',
      })
      const username = JSON.parse(localStorage.getItem("username"));
      this.usuarios = data.filter((ele) => ele.username !== username);
    },
  },
  computed: {
    filterVariables() {
      var $this = this;
      return $this.usuarios.filter(function (data) {
        return (
          $this.filtroNombre == "" ||
          data.username.toLowerCase().includes($this.filtroNombre.toLowerCase())
        );
      });
    },
  },
};
</script>

<style scoped>
.titulo {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #2c3e50;
}

.shadow {
  box-shadow: 2px 1px 5px -4px;
}

.shadowInputs {
  box-shadow: 1px 1px 5px -5px;
}
</style>
